import {
	historieVoorSchooljaren,
	isSchooljaarFilterVan,
	SCHOOLJAAR_HISTORIE_FILTERS,
	SCHOOLJAAR_INDICATOR_FILTERS,
	SchooljaarHistorieOption,
} from '@cumlaude/shared-utils';

type FilterMetWaarden = { field: string; values: string[] };

/**
 * Vervangt het gewone schooljaarfilter uit een antwoord van het model door de queryparameters van de
 * historiefilters. Met te weinig schooljaren geldt de standaardperiode van het dashboard.
 */
export function vertaalNaarHistorie(filter: FilterMetWaarden[] | null | undefined): {
	filter: FilterMetWaarden[] | undefined;
	queryParams: { [key: string]: string };
} {
	const filters = filter ?? undefined;
	const gevonden = SCHOOLJAAR_HISTORIE_FILTERS.find((f) => filters?.some((fl) => isSchooljaarFilterVan(f, fl.field)));
	if (!filters) return { filter: filters, queryParams: {} };
	if (!gevonden) return { filter: beperkTotEindjaar(filters), queryParams: {} };

	const rest = filters.filter((fl) => !isSchooljaarFilterVan(gevonden, fl.field));
	const schooljaren = [...new Set(filters.filter((fl) => isSchooljaarFilterVan(gevonden, fl.field)).flatMap((fl) => fl.values))].sort();
	if (schooljaren.length < gevonden.minimum) return { filter: rest, queryParams: {} };

	const waarde = historieVoorSchooljaren(schooljaren);
	const queryParams: { [key: string]: string } = { [gevonden.historie]: JSON.stringify([waarde]) };
	if (waarde.option === SchooljaarHistorieOption.AANGEPAST) queryParams[gevonden.aangepast] = JSON.stringify(schooljaren);

	return { filter: rest, queryParams };
}

/**
 * Het schooljaarfilter van de indicatordashboards is één eindschooljaar; bij meerdere waarden telt het hoogste jaar.
 */
function beperkTotEindjaar(filters: FilterMetWaarden[]): FilterMetWaarden[] {
	return filters.map((fl) =>
		SCHOOLJAAR_INDICATOR_FILTERS.includes(fl.field) && fl.values.length > 1 ? { field: fl.field, values: [[...fl.values].sort().at(-1)!] } : fl
	);
}
